
/* System defined core library */
import { Injectable } from '@angular/core';
import * as moment from 'moment';

/* User defined models */
import { AppointmentDetail } from '../models/scheduling/appointmentdetail.model';
import { OverlapsDate } from '../models/scheduling/overlapsDate.model';
import { OverlapRange } from '../models/scheduling/overlapRange.model';
import { Exam } from '../models/scheduling/exam.model';
import { Test } from '../models/scheduling/test.model';
import { BatteryConfig } from '../models/scheduling/batteryConfig.model';


@Injectable()
export class ExamFeatureService {

  constructor() {

  }

  // this function takes an array of date ranges in this format:
  // [{ start: Date, end: Date}]
  // the array is first sorted, and then checked for any overlap

  static overlapStart(dateRanges: OverlapsDate[]) {
    let maxDates: any = [];

    dateRanges.forEach((date: any) => {
      maxDates.push(date.start); //Getting maxStartDates collections
    });

    return maxDates.reduce(function (a: any, b: any) { return a > b ? a : b; }); //calculating MaxOverlapDate
  }

  static overlapEnd(dateRanges: OverlapsDate[]) {
    let minDates: any = [];

    dateRanges.forEach((date: any) => {
      minDates.push(date.end); //Getting minEndDates collections
    });

    return minDates.reduce(function (a: any, b: any) { return a < b ? a : b; }); //calculating minOverlapDate
  }

  static calculateOverlapDates(collections: AppointmentDetail[]): OverlapRange {
    if (collections !== undefined && collections !== null && collections.length > 0) {
      let ranges: any = [];
      let startDate: string = '';
      let endDate: string = '';
      collections.forEach((item: AppointmentDetail) => {
        let tempOverlapsDate: OverlapsDate = new OverlapsDate(
          item.exam.startDate ? moment(item.exam.startDate).format() : null,
          item.exam.endDate ? moment(item.exam.endDate).format() : null
        );
        ranges.push(tempOverlapsDate);

        if (collections.length == 1) {
          startDate = item.exam.startDate;
          endDate = item.exam.endDate;
        }
      });

      let overlapEndDate: string = ExamFeatureService.overlapEnd(ranges);
      let overlapStartDate: string = ExamFeatureService.overlapStart(ranges);

      if ((overlapStartDate != null || overlapStartDate != undefined) && (overlapEndDate != null || overlapEndDate != undefined)) {
        return new OverlapRange(
          moment(overlapStartDate).format('DD MMMM YYYY') + ' to ' + moment(overlapEndDate).format('DD MMMM YYYY'),
          moment(overlapStartDate).format('MM/DD/YYYY'),
          moment(overlapEndDate).format('MM/DD/YYYY')
        );
      }
      else {
        if (collections.length == 1) {
          return new OverlapRange(
            moment(startDate).format('DD MMMM YYYY') + ' to ' + moment(endDate).format('DD MMMM YYYY'),
            moment(startDate).format('MM/DD/YYYY'),
            moment(endDate).format('MM/DD/YYYY')
          );
        }
        else {
          return new OverlapRange('No overlap in Testing Window');
        }
      }
    } else {
      return new OverlapRange('');
    }
  }

  /* Returns the total duration for the given appointments */
  static calculateTotalDuration(appointmentDetails: AppointmentDetail[], batteryConfig?: BatteryConfig) {
    let duration: number = 0;
    let scheduleDuration: number = 0;

    if (appointmentDetails.length > 0) {
      appointmentDetails.forEach((appointment) => {
        if (appointment.status && appointment.status.toLowerCase() != 'cancelled') {
          duration += appointment.appointmentSlot.duration || 0;
        }
      });
      if (!duration) {
        appointmentDetails.forEach(appt => {
          duration += appt.exam.duration;
          scheduleDuration += appt.exam.schedule.duration;
        });
      }
      const apptSlot = appointmentDetails[0].appointmentSlot
      if (apptSlot && !apptSlot.testTime) {
        // need to add survey duration only before creating slot
        // so check if there's a slot and add bufferTime
        // also check if exam duration has already been updated to include survey time
        if (batteryConfig && batteryConfig.bufferTime > 0 && duration === scheduleDuration) duration += batteryConfig.bufferTime;
      }
    }
    return duration;
  }

  /* Return the total duration for given appointment holds, used for schedule and re-schedule flow */
  static calculateTotalHoldDuration(appointmentDetails: AppointmentDetail[]) {
    let duration: number = 0;
    if (appointmentDetails.length > 0) {
      appointmentDetails.forEach(appointment => {
        if (appointment.hold && appointment.hold.slot && appointment.hold.slot.duration && !isNaN(appointment.hold.slot.duration)) {
          duration += appointment.hold.slot.duration;
        }
      });
      if (duration == 0) {
        appointmentDetails.forEach(appointment => duration += appointment.exam.duration);
      }
    }
    return duration;
  }

  /* used for .sort() on Exam[]s */
  static compareExamsForSort(e1: Exam, e2: Exam): number {
    if (e1.name === e2.name) {
      return 0;
    } else {
      return e1.name < e2.name ? -1 : 1;
    }
  }

  /* used for .sort() on appointmentDetail[]s */
  static compareAppointmentDetailForSort(a1: AppointmentDetail, a2: AppointmentDetail): number {
    return ExamFeatureService.compareExamsForSort(a1.exam, a2.exam);
  }

  /* used for .sort() on test[]s */
  static compareTestForSort(t1: Test, t2: Test): number {
    let value = ExamFeatureService.compareExamsForSort(t1.exam, t2.exam);
    if (value === 0) {
      if (t1.sessions[0].sessionId === t2.sessions[0].sessionId) {
        return 0;
      } else {
        return t1.sessions[0].sessionId < t2.sessions[0].sessionId ? -1 : 1;
      }
    }
    return value;
  }
}